import * as React from 'react';
import styled from 'styled-components';

const StatisticBlock = ({ label, value }: Props) => (
  <Card>
    <Label>{label}</Label>
    <Value title={String(value)}>{value}</Value>
  </Card>
);

const Card = styled.div`
  background: var(--neutral-0);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow-xs);
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  box-sizing: border-box;
`;

const Label = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--neutral-500);
`;

const Value = styled.div`
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--mainText);
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

interface Props {
  label: string;
  value: string | number;
}

export default StatisticBlock;
